<template>
  <LoginMain />
</template>

<script>
import LoginMain from '@/components/LoginMain'

export default {
  components: {
    LoginMain
  }
}
</script>
